import type { Product } from 'app/features/recommend/interfaces/models';
import { isATRShoes } from '~/features/recommend/utils/isATRShoes';
import { conditionalConfirm } from '~/utils/conditionalConfirm';
import type { CommonImpressionFieldObject } from '~/utils/gtag';
import { sendGAEvent, sendGAProductClick } from '~/utils/gtag';
import { openLink } from '~/utils/openLink';

export const toEcSite = (
  page: 'home' | 'event' | 'predict' | 'measured',
  listName: string,
  listPosition: number,
  message: string,
  link?: string,
  product?: Product,
) => {
  if (link && product) {
    conditionalConfirm(isATRShoes(link), message, () => {
      sendGAEvent({
        action: 'click',
        category: 'link',
        label: `stepnote_${page}`,
        value: 1,
      });
      const url = new URL(product.link);
      const brandMapping: { [key: string]: string } = {
        'www.asics.com': 'ASICS',
        'www.asics-trading.co.jp': 'ATR',
      };
      const item: CommonImpressionFieldObject = {
        item_id: product.product_id.toString(),
        item_name: product.name,
        item_hostname: url.hostname,
        item_list_id: listName,
        item_list_name: listName,
        index: listPosition,
        item_variant: product.size.value.toString(),
        price: product.price ?? 0,
        affiliation: 'stepnote',
        item_brand: brandMapping[url.hostname] || '',
        item_category: product.item_category ?? '',
        item_size: product.size.value,
        currency: product.currency ?? '',
        quantity: 1,
      };

      sendGAProductClick({ item });
      openLink(
        link,
        new URLSearchParams({
          utm_campaign: `stepnote_${page}`,
          utm_source: 'stepnote',
          utm_medium: 'referral',
        }),
      );
    });
  }
};
